function priceUpdate() {
  setTimeout(function() {  
var hideDiv = document.querySelectorAll(".grid-item.one-third.medium-down--one-third.medium-down--text-left.text-right");
    var originalHide = hideDiv[1].querySelector(".cart-item--original-price")
      if(originalHide){
       originalHide.style.display = 'none';
      }
      var replacePrice = hideDiv[1].querySelector(".h2 small");
  console.log("replacePricereplacePrice=====",replacePrice);
    var Price = document.querySelector(".wh-original-price");
    console.log("this is the price=====",Price);
    var UPrice = Price.querySelector("small");
      replacePrice.textContent = UPrice.textContent;
          var QuantityButton = document.querySelector(".ajaxifyCart--qty");
      if (QuantityButton) {
          QuantityButton.style.pointerEvents = "none";
      }
}, 1800);
  
console.log('Price updated!'); 
  setTimeout(function() { 
  if (window.location.href.includes("citronella-spray-anti-bark-collar-recharegable-free-shipping")) {
var inputElement = document.querySelector('.ajaxifyCart--num');
var inputValue = parseInt(inputElement.value); 
    
// Update the HTML element with the new value based on the input value
var spanElement = document.querySelector('#ajaxifyCart .cart-form span.h2');
var smallElement = spanElement.querySelector('#ajaxifyCart .cart-form span.h2 small');
var visuallyHiddenElement = spanElement.querySelector('#ajaxifyCart .cart-form span.h2 .visually-hidden');
console.log("smallElement====",smallElement,spanElement, visuallyHiddenElement);
    var getProduct = document.getElementById("cart_row_citronella_spray_can_-_Single");
    console.log("this is the additional product========",getProduct);

//Update the content based on different input values
    if(getProduct){
switch (inputValue) {
    case 1:
        smallElement.innerHTML = "$0 ";
        visuallyHiddenElement.innerHTML = "$0 ";
        break;
    case 2:
        smallElement.innerHTML = "$10 ";
        visuallyHiddenElement.innerHTML = "$10 ";
        break;
    case 3:
        smallElement.innerHTML = "$19 ";
        visuallyHiddenElement.innerHTML = "$19 ";
        break;
    case 4:
        smallElement.innerHTML = "$27 ";
        visuallyHiddenElement.innerHTML = "$27 ";
        break;
        case 5:
        smallElement.innerHTML = "$37 ";
        visuallyHiddenElement.innerHTML = "$37 ";
        break;
    case 6:
        smallElement.innerHTML = "$40 ";
        visuallyHiddenElement.innerHTML = "$40 ";
        break;
    case 11:
        smallElement.innerHTML = "$75 ";
        visuallyHiddenElement.innerHTML = "$75 ";
        break;
           case 21:
        smallElement.innerHTML = "$130 ";
        visuallyHiddenElement.innerHTML = "$130 ";
        break;
    default:
        // Handle other cases if needed
        break;
}
    }

var originalPrices = document.querySelectorAll(".ajaxify-modal.is-visible .cart-item--original-price");
originalPrices.forEach(function(originalPrice) {
  originalPrice.style.display = 'none';
});

var quantitySelectors = document.querySelectorAll(".ajaxifyCart--qty");
       console.log("This is quantitySelectors =======",quantitySelectors);
console.log("This is the PricePlus=====", quantitySelectors);
quantitySelectors.forEach(function(selector) {
  selector.style.display = 'none';
});
}
}, 2000);
}



jQuery(document).ready(function(){
    jQuery(document).on('click','.is_bundle_cart #addToCart', function(e){
  e.preventDefault();
if (window.location.href.includes("citronella-spray-anti-bark-collar-recharegable-free-shipping")) { 
    setTimeout(function(){
      var crossItem = document.querySelectorAll(".ajaxifyCart--remove");
      console.log("This is the crossItem==========",crossItem);
        crossItem.forEach(function(item) {
            item.addEventListener("click", function() {
              console.log("item clicked");
              priceUpdate();
            });
        });
        }, 2000);

  
var current_id = $('#productSelect-product-template option:first').val();
console.log("This is the item=======", current_id);
var item = $('.single-option-selector').eq(1).find(":selected").text();
var id = jQuery('.bid').attr('variant-id');
var id_2 = jQuery('.bid2').attr('variant-id');
var skuid = $('#productSelect-product-template').find(":selected").attr('data-sku');
console.log("This is skuid=====", skuid);
var arr = skuid.split(" ");

console.log('jukuy', id);
//Current Product Quantity
var quantity = $('.js-qty .js--num').val();

var qty;

switch (item) {
    case "One Free Can":
        qty = 1;
        // Include id_2 only for "One Free Can" case
        var prod_items = [{
       id: current_id,
       quantity: 1
        }, {
            quantity: qty,
            id: id_2
        }];
        break;

    case "1 Extra cans $9.99":
        qty = 2;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;
    case "2 Extra cans $19":
        qty = 3;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;
    case "3 Extra cans $27":
        qty = 4;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;

    case "5 Extra cans $40":
        qty = 6;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;

    case "10 Extra cans $75":
        qty = 11;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;

    case "20 Extra cans $130":
        qty = 21;
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;

    default:
        qty = 0; // Default value if item is not matched
        var prod_items = [{
            id: current_id,
            quantity: quantity
        }, {
            id: id,
            quantity: qty
        }];
        break;
}

jQuery.ajax({
    type: "POST",
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    data: {
        items: prod_items
    },
    success: function (data) {
        console.log(data);
        console.log("data");
        $('.header-cart-btn.cart-toggle.tdf_cart_icon').trigger('click');
    },
    error: function (textStatus, errorThrown) {
        console.log('error', textStatus);
    }
});

setTimeout(function(){
if (window.location.href.includes("citronella-spray-anti-bark-collar-recharegable-free-shipping")) {
var originalPrices = document.querySelectorAll(".ajaxify-modal.is-visible .cart-item--original-price");
originalPrices.forEach(function(originalPrice) {
  originalPrice.style.display = 'none';
});

var quantitySelectors = document.querySelectorAll(".ajaxifyCart--qty");
       console.log("This is quantitySelectors =======",quantitySelectors);
console.log("This is the PricePlus=====", quantitySelectors);
quantitySelectors.forEach(function(selector) {
  selector.style.display = 'none';
});
  
var inputElement = document.querySelector('.ajaxifyCart--num');
var inputValue = parseInt(inputElement.value);

// Update the HTML element with the new value based on the input value
var spanElement = document.querySelector('.cart-form span.h2');
var smallElement = spanElement.querySelector('.cart-form span.h2 small');
var visuallyHiddenElement = spanElement.querySelector('.cart-form span.h2 .visually-hidden');
console.log("smallElement====",smallElement,spanElement, visuallyHiddenElement);
var getProduct = document.getElementById("cart_row_citronella_spray_can_-_Single");
console.log("this is the additional product========",getProduct);

//Update the content based on different input values
if(getProduct){ 
switch (inputValue) {
    case 1:
        smallElement.innerHTML = "$0 ";
        visuallyHiddenElement.innerHTML = "$0 ";
        break;
    case 2:
        smallElement.innerHTML = "$10 ";
        visuallyHiddenElement.innerHTML = "$10 ";
        break;
    case 3:
        smallElement.innerHTML = "$19 ";
        visuallyHiddenElement.innerHTML = "$19 ";
        break;
    case 4:
        smallElement.innerHTML = "$27 ";
        visuallyHiddenElement.innerHTML = "$27 ";
        break;
        case 5:
        smallElement.innerHTML = "$37 ";
        visuallyHiddenElement.innerHTML = "$37 ";
        break;
    case 6:
        smallElement.innerHTML = "$40 ";
        visuallyHiddenElement.innerHTML = "$40 ";
        break;
        case 10:
        smallElement.innerHTML = "$40 ";
        visuallyHiddenElement.innerHTML = "$67";
        break;
    case 11:
        smallElement.innerHTML = "$75 ";
        visuallyHiddenElement.innerHTML = "$75 ";
        break;
           case 21:
        smallElement.innerHTML = "$130 ";
        visuallyHiddenElement.innerHTML = "$130 ";
        break;
    default:
        // Handle other cases if needed
        break;
}
}
  }
}, 2000);
}
else if(window.location.href.includes("copy-of-citronella-spray-can-1") || window.location.href.includes ("citronella-spray-can")){
  console.log("Entered in ELSE IF conditions");
  var current_id = $('#productSelect-product-template option:first').val();
  console.log("This is the item=======***********", current_id);
  var item = $('.single-option-selector').find(":selected").text();
  console.log("This is the item=======", item);
  var id = jQuery('.bid').attr('variant-id');
  var id_2 = jQuery('.bid2').attr('variant-id');
  var skuid = $('#productSelect-product-template').find(":selected").attr('data-sku');
  var arr = skuid.split(" ");

  console.log('jukuy', id);
  var quantity = $('.js-qty .js--num').val();

  var qty;
  switch (item) {
    case "Single Can":
      qty = 1;
      break;
    case "Pack of 5 Cans":
      qty = 5;
      break;
    case "Pack of 10 Cans":
      qty = 10;
      break;
    case "Pack of 20 Cans":
      qty = 20;
      break;
    default:
      qty = 0; // Default value if item is not matched
      break;
  }

  var prod_items;

  // Check if bundle product or variation selector exists
  if ($('.selector-wrapper').css("display") == "none") {
    var num = arr[3].replace(/([-,.€~!@#$%^&*()_+=`{}\[\]\|\\:;'<>])+/g, '');
    if (num == 3) {
      qty = 2; // Override qty if num is 3
    }
    prod_items = [{ quantity: 1, id: id }, { quantity: qty, id: id_2 }];
    console.log("prod_items======", prod_items);
  } else {
    console.log('gggghghg');
    // Only add the bundle product to the cart
    prod_items = [{ id: id, quantity: qty }];
  }

  jQuery.ajax({
    type: "POST",
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    data: { items: prod_items },
    success: function (data) {
      console.log(data);
    console.log("replacePricereplacePrice=====");    
      console.log("data");
      $('.header-cart-btn.cart-toggle.tdf_cart_icon').trigger('click');
    },
    error: function (textStatus, errorThrown) {
      console.log('error', textStatus);
    }   
  });  

    setTimeout(function() {
    var abc = document.querySelector(".grid-item.one-third.medium-down--one-third.medium-down--text-left.text-right");
    var originalHide = document.querySelector(".grid-item.one-third.medium-down--one-third.medium-down--text-left.text-right .cart-item--original-price")
    var replacePrice = abc.querySelector(".h2 small");
    var Price = document.querySelector(".wh-original-price");
    var UPrice = Price.querySelector("small");
      replacePrice.textContent = UPrice.textContent;
      if(originalHide){
       originalHide.style.display = 'none';
      }
      var QuantityButton = document.querySelector(".ajaxifyCart--qty");
      if (QuantityButton) {
          QuantityButton.style.pointerEvents = "none";
      }
}, 3000);

  
}
 else{
       console.log("Entered in ELSE conditions");
      var current_id = $('#productSelect-product-template option:first').val();
       console.log("This is the item=======***********",current_id);
      var item = $('.single-option-selector').find(":selected").text();
      console.log("This is the item=======",item);
      var id = jQuery('.bid').attr('variant-id');
      var id_2 = jQuery('.bid2').attr('variant-id');
      var skuid = $('#productSelect-product-template').find(":selected").attr('data-sku');
      var arr = skuid.split(" ");
  
      console.log('jukuy',id);
      //Current Product Quantity
      var quantity = $('.js-qty .js--num').val();
  
      var qty;
  
      switch (item) {
        case "2":
          qty = 1;
          break;
        case "3":
          qty = 2;
          break;
        case "4":
          qty = 3;
          break;
        // Add cases for item values from 5 to 20
        case "5":
          qty = 4;
          break;
        // Add more cases as needed
        default:
          qty = 0; // Default value if item is not matched
          break;
      }
  
      var prod_items;
  
      // Check if bundle product or variation selector exists
      if($('.selector-wrapper').css("display") == "none") {
        var num = arr[3].replace(/([-,.€~!@#$%^&*()_+=`{}\[\]\|\\:;'<>])+/g, '');
        if(num == 3) {
          qty = 2; // Override qty if num is 3
        }
        prod_items = [{ quantity: 1, id: id }, { quantity: qty, id: id_2 }];
        console.log("prod_items======",prod_items);
      } else {
        console.log('gggghghg');
        prod_items = [{ id: current_id,  quantity: quantity }, { id: id,  quantity: qty }];
      }
  
      jQuery.ajax({   
        type: "POST",
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        data: { items: prod_items },
        success: function(data) {
          console.log(data);
          console.log("data");
          $('.header-cart-btn.cart-toggle.tdf_cart_icon').trigger('click');
        },
        error: function (textStatus, errorThrown) {
          console.log('error', textStatus);
        }
      });
    }       

    });
  
    // Check variation
    setTimeout(function(){
      if($('.selector-wrapper').css("display") == "none") {
        $('#addToCart').addClass('no_variation');
      } else {
        $('#addToCart').addClass('has_variation');
      }
    }, 1000);
  
    jQuery(document).on('click','.ajaxifyCart--remove', function(){
      $('#myDiv').css("display","block");
      setTimeout(function(){
        $('#myDiv').css("display","none");
      }, 3000);
    });
  
    jQuery(document).on('click', '.ajaxifyCart--close', function(){
            location.reload();
      if($('.cart-form').length != 1) {
        location.reload();
      }
    });
  });





var checkIframe = setInterval(function() {
        var cartButton = document.querySelector('.header-cart-btn.cart-toggle.tdf_cart_icon');
        console.log("cartButton",cartButton);
    if (cartButton) {

          var hideDivs = document.querySelectorAll(".grid-item.one-third.medium-down--one-third.medium-down--text-left.text-right");
    hideDivs.forEach(function(hideDiv) {
        var originalHide = hideDiv.querySelector(".cart-item--original-price");
        if (originalHide) {
            originalHide.style.display = 'none';
        }
            var replacePrice = hideDiv.querySelector(".h2 small");
            console.log("replacePrice=====", replacePrice);
            var Price = document.querySelector(".wh-original-price");
            console.log("this is the price=====", Price);
            var UPrice = Price.querySelector("small");
            replacePrice.textContent = UPrice.textContent;
            var QuantityButton = document.querySelector(".ajaxifyCart--qty");
            if (QuantityButton) {
                QuantityButton.style.pointerEvents = "none";
            }
    }.bind(this));
      clearInterval(checkIframe);
      cartButton.addEventListener('click', function() {
      priceUpdate();
      setTimeout(function(){
      var crossItem = document.querySelectorAll(".ajaxifyCart--remove");
        crossItem.forEach(function(item) {
            item.addEventListener("click", function() {
              console.log("item clicked");
              priceUpdate();
              var originalPrices = document.querySelectorAll(".ajaxify-modal.is-visible .cart-item--original-price");
              originalPrices.forEach(function(originalPrice) {
                originalPrice.style.display = 'none';
              });
            });
        });
        }, 2000);
});
}
  }, 100);



document.addEventListener("DOMContentLoaded", function() {
if (window.location.href.includes("citronella-spray-anti-bark-collar-recharegable-free-shipping") || 
    window.location.href.includes("copy-of-citronella-spray-can-1") || 
    window.location.href.includes("citronella-spray-can")) {
  // alert("checking");

    var CartCount = document.querySelector(".cart-count.cart-badge--desktop");
    console.log("CartCountCartCountCartCount====", CartCount, CartCount.textContent);
    var CartCountValue = parseInt(CartCount.textContent);
    if (CartCountValue > 0) {
        var findProduct = document.getElementById("cart_row_Citronella_Spray_Anti_Bark_Collar");
      var findSecondProduct = document.getElementById("cart_row_citronella_Spray_can_-_Single");
        if (findProduct || findSecondProduct) {
            var CartButton = document.getElementById("addToCart");
            if (CartButton) {
                CartButton.style.pointerEvents = "none";
                CartButton.style.opacity = 0.4;
                // Check if loremIpsumText already exists
                var loremIpsumText = document.querySelector("#loremIpsumText");
                if (!loremIpsumText) {
                    // Create a new element for Lorem Ipsum text
                    loremIpsumText = document.createElement("div");
                    loremIpsumText.id = "loremIpsumText";
                    loremIpsumText.textContent = "Clear the Bundle from cart and then add the different bundle combinations";
                    loremIpsumText.style.color = '#ff8000';
                    CartButton.parentNode.appendChild(loremIpsumText);
                }
            }
        }
    }
}
});


if (window.location.href.includes("citronella-spray-anti-bark-collar-recharegable-free-shipping") || 
    window.location.href.includes("copy-of-citronella-spray-can-1") || 
    window.location.href.includes("citronella-spray-can")) {
    document.addEventListener("click", function() {
    var CartCount = document.querySelector(".cart-count.cart-badge--desktop");
    var CartCountValue = parseInt(CartCount.textContent);
    if (CartCountValue > 0) {
        var findProduct = document.getElementById("cart_row_Citronella_Spray_Anti_Bark_Collar");
        var findSecondProduct = document.getElementById("cart_row_citronella_Spray_can_-_Single");
         if (findProduct || findSecondProduct) {
            var CartButton = document.getElementById("addToCart");
            if (CartButton) {
                CartButton.style.pointerEvents = "none";
                 CartButton.style.opacity = 0.4;
                // Check if loremIpsumText already exists
                var loremIpsumText = document.querySelector("#loremIpsumText");
                if (!loremIpsumText) {
                    // Create a new element for Lorem Ipsum text
                    loremIpsumText = document.createElement("div");
                    loremIpsumText.id = "loremIpsumText";
                    loremIpsumText.textContent = "Clear the Bundle from cart and then add the different bundle combinations";
                    loremIpsumText.style.color = '#ff8000';
                    CartButton.parentNode.appendChild(loremIpsumText);
                }
            }
        }
    }
    });
}

function hideDiv() {
setTimeout(function() {  
var hideDiv = document.querySelectorAll(".grid-item.one-third.medium-down--one-third.medium-down--text-left.text-right");
console.log("cvgfdyhjsvcsvhj===", hideDiv[1]);
if (hideDiv.length >= 2) {
    hideDiv[1].style.display = 'none';
    console.log("Second element hidden.");
} else {
    console.log("Second element not found.");
}
}, 1500);
}


var CartButton = document.getElementById("addToCart");
console.log("CartButton====", CartButton);
if (CartButton) {
    CartButton.addEventListener("click", function() {
        setTimeout(function() {
            // alert("Item added to cart!");
        }, 3000);
    });
}